const messages = {
  "title": "Investeringssteun",
  "description": "Bridgestone ondersteunt u ook individueel bij uw zakelijke investeringen. Ongeacht of u machines of werkplaatsuitrusting aanschaft, vervangende werkplaatsvoertuigen of marketingactiviteiten zoals het plaatsen van advertenties of online banners, enz. - gebruik uw BRIDGESTONE PLUS spaarpunten om uw investeringen te herfinancieren. Nadat u heeft geinvesteerd, dient u hier eenvoudig de factuur van de betreffende aanbieder in en geeft u hier aan hoeveel van uw spaarpunten u wilt gebruiken. Volg de hieronder beschreven instructies.",
  "description_old": "Investeringssteun voor werkplaatsuitrusting, reclamesubsidie voor marketingprojecten",
  "info": {
    "paragraph2_old": "Zorg ervoor dat uw werkplaatsuitrusting of verkoopruimte up-to-date is of maak reclame om uw producten beter op de markt te brengen. Vertel ons hoeveel punten u voor deze bonus wilt betalen. De minimale punteneis bedraagt 1.250 punten, waarde per punt = 0,25 EUR",
    "paragraph2": "U voert uw gewenste investering uit en rekent de derdenfactuur af.",
    "paragraph3_old": "Om de premie te kunnen factureren hebben wij uw factuur nodig voor het aantal behaalde punten (aantal punten x 0,25 EUR = netto factuurbedrag) en een kopie van de originele factuur. U vindt een voorbeeldfactuur",
    "paragraph3": "Tenslotte dient u de subsidieaanvraag in het vragenveld rechts op deze pagina in",
    "paragraph4_old": "Wij verzoeken u persoonlijk contact met ons op te nemen om de vervolgstappen te zetten."
  },
  "excludeText": "Begrijp alstublieft dat investeringen in aanbiedingen van directe concurrentie zijn uitgesloten.",
  "here": "hier",
  "contactPerson": "Contactpersoon",
  "email": "E-Mail",
  "phone": "Tel",
  "payInfo": "Uitbetaling kan tot 8 weken duren!"
};

export default {
  messages,
};
